import get from 'lodash/get';
import PropTypes from 'prop-types';

import DownloadArtifactButton from './DownloadArtifactButton';

const DownloadNoteButton = props => {
  const {iconOnly, textOnly, session} = props;
  return (
    <DownloadArtifactButton 
      {...props}
      session={session}
      docType='note'
      iconOnly={iconOnly}
      textOnly={textOnly}
    />
  );
};

DownloadNoteButton.defaultProps = {
  iconOnly: false,
  textOnly: false,
};

DownloadNoteButton.propTypes = {
  session: PropTypes.object,
  iconOnly: PropTypes.bool,
};

export default DownloadNoteButton;
